import { Box, Grid, Typography } from "@mui/material";
import React from "react";

import PinkButton from "../../components/customButtons/PinkButton";

export default function NewPage500() {
  return (
    <>
      <Box
        
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        width="100%"
      >
        <Box width={548}>
          <img src="/newdashboard/ErrorPageIcons/358547934_b0652d0a-18d1-4dfb-92ab-b5e7b6adeb90 1.png" />
        </Box>

        <Typography
        mt={2}
          color="#000000"
          fontFamily="Inter"
          fontSize="26px"
          letterSpacing="1px"
          lineHeight="100%"
          style={{ fontWeight: 700 }}
        >
          {" "}
          Internal {" "} Server {" "} Error
        </Typography>

        <Typography
          color="#000000"
          fontFamily="Inter"
          fontSize="20px"
          mt={2}
          letterSpacing="0px"
          textAlign="center"
          style={{ fontWeight: 400 }}
        >
          {" "}
    Something went wrong on the server. Please try again later.
        </Typography>

        <Box mt={3}>
          <PinkButton
            buttonTitle="Retry"
            startIcon={<img src="/newdashboard/ErrorPageIcons/fa_repeat.png" />}
          />
        </Box>
      </Box>
    </>
  );
}
